import { JsonPipe, NgClass } from '@angular/common';
import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges, ViewChild } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { ModalComponent } from '@scalefast/components/modal';
import { CartProduct } from '@scalefast/core';

@Component({
  selector: 'app-add-to-cart-template',
  styles: [
    '.add-to-cart__button { height:auto; border-radius: 65px; padding: 12px 32px; max-width: 100%; text-wrap: wrap; position:relative}',
  ],
  templateUrl: './add-to-cart-template.component.html',
  standalone: true,
  imports: [ReactiveFormsModule, NgClass, FormsModule, JsonPipe],
})
export class AppAddToCartTemplateComponent implements OnChanges {
  @Input() cartProduct?: CartProduct;
  @Input() productId: string | undefined;
  @Input() productTitle: string | undefined;
  @Input() productDescription: string | undefined;
  @Input() loading = false;
  @Input() includeQuantitySelector = false;
  @Input() small = false;
  @Output() addToCart = new EventEmitter<CartProduct>();
  @Output() resetAddToCartButton = new EventEmitter<boolean>(false);
  @ViewChild(ModalComponent) successfullyAddedModal: ModalComponent = new ModalComponent();

  addToCartForm: FormGroup;
  quantityArray: Array<number> = [];

  constructor() {
    this.addToCartForm = new FormGroup({});
  }

  get quantity(): AbstractControl<string, string> | null {
    return this.addToCartForm.get('quantity');
  }

  get hasStock(): boolean {
    if (!this.cartProduct) {
      return false;
    }
    return this.cartProduct.stock > 0;
  }

  get showQuantitySelector(): boolean {
    return this.includeQuantitySelector && this.hasStock;
  }

  get isButtonEnabled(): boolean {
    return this.hasStock && !this.loading;
  }

  resetButton(): void {
    this.resetAddToCartButton.emit(false);
  }

  createForm(): void {
    if (!this.cartProduct) return;

    this.resetButton();
    const maxUnits = this.cartProduct?.stock || 11;
    this.quantityArray = Array.from({ length: maxUnits }, (_, i) => i + 1);

    this.addToCartForm = new FormGroup({
      stock: new FormControl(maxUnits),
      quantity: new FormControl(1, Validators.compose([Validators.required, Validators.min(1), Validators.max(maxUnits)])),
      productId: new FormControl(this.cartProduct.productId, Validators.required),
      price: new FormControl(this.cartProduct.price),
      currency: new FormControl(this.cartProduct.currency),
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.cartProduct) {
      this.createForm();
    }
  }

  onSubmit() {
    const { stock, quantity, price, currency } = this.addToCartForm.value;
    if (!this.cartProduct) {
      throw new Error(
        `Adding not defined product to cart, available info product id: ${this.productId} form: ${JSON.stringify(this.addToCartForm.value)}`,
      );
    }
    const productData: any = {
      ...this.cartProduct,
      stock,
      quantity,
      productId: this.productId ?? '',
      title: this.productTitle ?? '',
      description: this.productDescription ?? '',
      image: this.cartProduct.image,
      price,
      currency,
      type: this.cartProduct?.type ?? '',
      categories: this.cartProduct?.categories,
      bundleProductsV4: this.cartProduct?.bundleProductsV4,
      specificV4: this.cartProduct?.specificV4,
      refID: this.cartProduct?.refID,
      product: this.cartProduct.product,
    };

    if (productData) {
      this.addToCart.emit(productData);
    }
  }
}
